exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1nkRDvQO4KImxQaNrDyTFF{max-width:50%;margin:0 auto}", ""]);

// exports
exports.locals = {
	"image": "_1nkRDvQO4KImxQaNrDyTFF"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&minimize&importLoaders=1!./~/postcss-loader!./src/pages/work/dlgsc/styles.module.css
// module id = ./node_modules/css-loader/index.js?modules&minimize&importLoaders=1!./node_modules/postcss-loader/index.js!./src/pages/work/dlgsc/styles.module.css
// module chunks = 3360190947491456000